import {ICriteriaColumnsProps} from "../models/CriteriaModels";
import {textSystem} from "../../utils/Constant";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import {EVALUATE_STATUS, RESULT, TYPE_MODAL} from "../constants/criteriaModal";
import moment from "moment";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import {FileActions} from "../components/FileActions";
import TextValidator from "../../component/TextValidator";
import React from "react";

export const QualityIndicatorColumns = (props: ICriteriaColumnsProps) => {
  const {handleOpenCriteriaModal} = props;
  return [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: "50px",
      },
      cellStyle: {
        width: "50px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => <span>{stt}</span>,
    },
    {
      name: "Thao tác",
      field: "",
      headerStyle: {
        width: "100px",
        minWidth: "100px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex justify-content-center gap-3">
          <CustomIconButton
            variant="view"
            onClick={() => handleOpenCriteriaModal(TYPE_MODAL.VIEW, row)}
          >
            <i className="bi bi-eye-fill text-gray-700"></i>
          </CustomIconButton>

          {row?.status !== EVALUATE_STATUS.EVALUATED.code && (
            <>
              <CustomIconButton
                variant="edit"
                onClick={() => handleOpenCriteriaModal(TYPE_MODAL.EDIT, row)}
              >
                <i className="bi bi-pencil-square text-primary"></i>
              </CustomIconButton>

              <CustomIconButton
                variant="evaluate"
                onClick={() =>
                  handleOpenCriteriaModal(TYPE_MODAL.EVALUATE, row)
                }
              >
                <i className="bi bi-check2-square text-navy"></i>
              </CustomIconButton>
            </>
          )}
        </div>
      ),
    },
    {
      name: "Hoàn thành đánh giá",
      field: "status",
      headerStyle: {
        width: "160px",
        minWidth: "160px",
      },
      cellStyle: {
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {
            Object.values(EVALUATE_STATUS).find(
              (item: any) => item.code === row?.status
            )?.name
          }
        </div>
      ),
    },
    {
      name: "Đợt đánh giá",
      field: "planName",
      cellStyle: {
        minWidth: "200px",
        ...textSystem,
      },
    },
    {
      name: "Khía cạnh",
      field: "partName",
      cellStyle: {
        minWidth: "160px",
        textAlign: "center",
        ...textSystem,
      },
    },
    {
      name: "Chỉ số",
      field: "chapterName",
      cellStyle: {
        minWidth: "160px",
        textAlign: "center",
        ...textSystem,
      },
    },
    {
      name: "Ngày tạo",
      field: "createdDate",
      cellStyle: {
        minWidth: "150px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {row?.createdDate
            ? moment(row?.createdDate).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
    {
      name: "Ngày cập nhật",
      field: "modifiedDate",
      cellStyle: {
        minWidth: "150px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {row?.modifiedDate
            ? moment(row?.modifiedDate).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
  ];
};

export const QualityIndicatorModalColumns = (props: any): any[] => {
  const {
    handleChangeTable,
    type,
    isView,
    touched,
    errors,
    handleViewFile,
    handleDownloadFile,
    criteria,
  } = props;
  const columnsFnc = additionalModalColumns(criteria?.chapterCode);
  const additionalColumns: any[] = columnsFnc(props) || [];

  return [
    {
      name: "Tên tiểu mục",
      field: "chapterName",
      cellStyle: {
        minWidth: "500px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <span className={`${row?.conclusionAssessment ? "text-navy" : ""}`}>
          {row?.name || row?.dimensionName}
        </span>
      ),
    },
    ...additionalColumns,
    {
      name: "Kết quả",
      field: "result",
      isVisible: type.modalType === TYPE_MODAL.EVALUATE,
      cellStyle: {
        minWidth: "110px",
        textAlign: "center",
        ...textSystem,
      },
    },
    {
      name: "Bằng chứng",
      field: "evidence",
      cellStyle: {
        width: "200px",
        minWidth: "200px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex align-items-center justify-content-center">
          <label className="custom-file-upload">
            <input
              type="file"
              onChange={(e) => {
                const file = e.target.files?.[0];
                handleChangeTable(index, file, "evidence", row);
              }}
              disabled={isView}
            />
            {row?.evidence?.name ? (
              <span className="text-info">{row?.evidence?.name}</span>
            ) : (
              <span className="text-info">
                Tải tệp lên <i className="bi bi-upload text-navy ms-2"></i>
              </span>
            )}
          </label>
          {row?.evidence?.name && (
            <FileActions
              file={row?.evidence}
              onView={handleViewFile}
              onDownload={handleDownloadFile}
              disabled={isView}
            />
          )}
          {touched[`evidence_${index}`] && errors[`evidence_${index}`] && (
            <div className="text-danger small mt-1">
              {errors[`evidence_${index}`]}
            </div>
          )}
        </div>
      ),
    },
    {
      name: "Kết luận",
      field: "conclusionAssessment",
      isVisible: type.modalType === TYPE_MODAL.EVALUATE,
      cellStyle: {
        width: "200px",
        minWidth: "200px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <AutocompleteV2
            options={RESULT}
            value={row?.conclusionAssessment || null}
            name="conclusionAssessment"
            onChange={(selectedOption) => {
              handleChangeTable(
                index,
                selectedOption,
                "conclusionAssessment",
                row
              );
            }}
            className="spaces width-100"
          />
          {touched[`conclusionAssessment_${index}`] &&
            errors[`conclusionAssessment_${index}`] && (
              <div className="text-danger small mt-1">
                {errors[`conclusionAssessment_${index}`]}
              </div>
            )}
        </div>
      ),
    },
    {
      name: "Ghi chú",
      field: "comment",
      isVisible: type.modalType === TYPE_MODAL.EVALUATE,
      cellStyle: {
        minWidth: "110px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <TextValidator
            className="spaces width-100"
            name="comment"
            value={row?.comment || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "comment", row);
            }}
          />
        </div>
      ),
    },
  ];
};

const additionalModalColumns = (indicator: string) => {
  switch (indicator) {
    case "B3":
      return adverseEventColumns;
    case "B4":
      return nonClinicalIncidentColumns;
    default:
      return divideColumns;
  }
}

const divideColumns = (props: any) => {
  const {handleChangeTable} = props;

  return [
    {
      name: "Tử số/Mẫu số",
      field: "comment",
      cellStyle: {
        minWidth: "120px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="numerator"
            value={row?.numerator || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "numerator", row);
            }}
          />
          <div className="mx-3">/</div>
          <TextValidator
            type="number"
            className="spaces width-100"
            name="denominator"
            value={row?.denominator || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "denominator", row);
            }}
          />
        </div>
      ),
    },
  ]
}

const adverseEventColumns = (props: any) => {
  const {handleChangeTable} = props;
  // AE: Adverse Event
  return [
    {
      name: "Do sử dụng thuốc",
      field: "comment",
      cellStyle: {
        minWidth: "160px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="medicalUseOfAE"
            value={row?.medicalUseOfAE || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "medicalUseOfAE", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Do tác dụng phụ của thuốc",
      field: "comment",
      cellStyle: {
        minWidth: "160px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="adverseEventADR"
            value={row?.adverseEventADR || ""} // Adverse drug reactions (ADRs)
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "adverseEventADR", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Do phẫu thuật",
      field: "comment",
      cellStyle: {
        minWidth: "120px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="relatedToSurgeryAE"
            value={row?.relatedToSurgeryAE || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "relatedToSurgeryAE", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Do thủ thuật",
      field: "comment",
      cellStyle: {
        minWidth: "120px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="medicalProcedureAE"
            value={row?.medicalProcedureAE || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "medicalProcedureAE", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Do truyền máu",
      field: "comment",
      cellStyle: {
        minWidth: "120px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="bloodTransfusionAE"
            value={row?.bloodTransfusionAE || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "bloodTransfusionAE", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Sự cố khác",
      field: "comment",
      cellStyle: {
        minWidth: "120px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="othersAE"
            value={row?.othersAE || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "othersAE", row);
            }}
          />
        </div>
      ),
    },
  ]
}

const nonClinicalIncidentColumns = (props: any) => {
  const {handleChangeTable} = props;
  // NCI: Non-Clinical Incident
  return [
    {
      name: "Tự sát",
      field: "comment",
      cellStyle: {
        minWidth: "100px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="suicideNCI"
            value={row?.suicideNCI || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "suicideNCI", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Ngã cao",
      field: "comment",
      cellStyle: {
        minWidth: "100px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="heightFallingNCI"
            value={row?.heightFallingNCI || ""} // Adverse drug reactions (ADRs)
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "heightFallingNCI", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Bắt cóc trẻ em",
      field: "comment",
      cellStyle: {
        minWidth: "160px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="childAbductionNCI"
            value={row?.childAbductionNCI || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "childAbductionNCI", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Hành hung, hãm hiếp, giết người",
      field: "comment",
      cellStyle: {
        minWidth: "160px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="violenceRelatedNCI"
            value={row?.violenceRelatedNCI || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "violenceRelatedNCI", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Cháy nổ",
      field: "comment",
      cellStyle: {
        minWidth: "100px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="explosionNCI"
            value={row?.explosionNCI || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "explosionNCI", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Rò rỉ, thất thoát vật liệu hoặc chất thải nguy hại cao",
      field: "comment",
      cellStyle: {
        minWidth: "160px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="hazardousMaterialLossNCI"
            value={row?.hazardousMaterialLossNCI || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "hazardousMaterialLossNCI", row);
            }}
          />
        </div>
      ),
    },
    {
      name: "Khác",
      field: "comment",
      cellStyle: {
        minWidth: "100px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex">
          <TextValidator
            type="number"
            className="spaces width-100"
            name="othersNCI"
            value={row?.othersNCI || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "othersNCI", row);
            }}
          />
        </div>
      ),
    },
  ]
}
